import { render } from "./MemosCreate.vue?vue&type=template&id=4208298e"
import script from "./MemosCreate.vue?vue&type=script&lang=js"
export * from "./MemosCreate.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__